/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The messaging service an external chat lives in.
 */
export type ExternalChatProvider =
  (typeof ExternalChatProvider)[keyof typeof ExternalChatProvider];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalChatProvider = {
  whatsapp: 'whatsapp',
} as const;
